<div *ngIf="!isHide && displayMode === 'login-page'" class="login">
	<div class="login-container">
		<div class="form-container">
			<div class="form-content">
			    <div class="login-page-logo-small visible-xs-inline-block" aria-hidden="true" role="presentation"></div>
				<form *ngIf='formMode === "login"' class="form-signin column" method="post">
					<div class="block">
						<div class="header">{{LOCALIZATION.loginWelcome}}</div>
						<p *ngIf="passwordEnabled && !isHideBasicAuthentication">{{LOCALIZATION.loginUsernamePasswordPrompt}}</p>
					</div>			
					<div class="row">
						<div class="col-md-12 btn-group" ngbDropdown *ngIf="adfsEnabled || azureEnabled">
							<div *ngIf="idplist.length > 1">
								<button id="single-button" type="button" class="btn btn-danger" ngbDropdownToggle aria-haspopup="true" style="width:100%">
									{{LOCALIZATION.signIn}} <span class="caret"></span>
								</button>
								<ul class="dropdown-menu" ngbDropdownMenu role="menu" aria-labelledby="single-button" style="width:100%">
									<li class="loginLabel text-center" *ngFor="let idp of idplist" role="menuitem"><a href="/aw-server/saml/login?idp={{idp.url}}">{{idp.name}}</a></li>
								</ul>
							</div>
							<div *ngIf="idplist.length == 1" class="text-center">
								<a class="btn btn-danger" href="/aw-server/saml/login?idp={{idplist[0].url}}" role="button">{{idplist[0].name}}</a>
							</div>
							<div *ngIf="azureEnabled" class="text-center">
								<a class="btn btn-primary text-white" href="/aw-server/rest/security/azurelogin" role="button">{{LOCALIZATION.loginAzureAD}}</a>
							</div>
						</div>
						<div class="col-md-12 panel-divider" *ngIf="(passwordEnabled && !isHideBasicAuthentication || ldapEnabled) && (adfsEnabled || azureEnabled)">
							<div>{{LOCALIZATION.or}}</div>
							<hr>
						</div>
						<div class="col-md-12" *ngIf="passwordEnabled  && !isHideBasicAuthentication || ldapEnabled">
							<label for="loginUsername" class="loginLabel">{{LOCALIZATION.username}}</label>
							<input type="text" 
								[(ngModel)]='input.username' 
								id="loginUsername" 
								name="loginUsername" 
								autocomplete="username"
								(keyup.enter)="ok()" 
								class="form-control" 
								required autofocus />
							<label for="loginPassword" class="loginLabel">{{LOCALIZATION.password}}</label>
							<input type="password" 
								[(ngModel)]='input.password' 
								id="loginPassword" 
								name="loginPassword" 
								autocomplete="current-password"
								(keyup.enter)="ok()" 
								class="form-control" 
								required />
							<br>
							<div class="primary-controls">
								<button class="btn btn-default" type="button" (click)="cancel()" *ngIf="publicEnabled">{{LOCALIZATION.cancel}}</button>
								<button id="login" class="btn btn-primary" type="button" (click)="ok()">{{LOCALIZATION.login}}</button>
							</div>
						</div>
					</div>
				</form>
			
				<form *ngIf='formMode === "register"' name="userForm" class="form-signin column" method="post">
					<div class="block">
						<div class="header">{{LOCALIZATION.register}}</div>
						<p>{{LOCALIZATION.loginCredentialsPrompt}}</p>
					</div>
					<div class="row">			
						<div class="col-md-12">
							<label for="inputUsername" class="loginLabel">{{LOCALIZATION.username}}</label>
								<input type="text" [(ngModel)]='input.username' id="inputUsername" name="inputUsername" class="form-control" required autofocus>
							<label for="inputEmail" class="loginLabel">{{LOCALIZATION.email}}</label>
								<input type="text" [(ngModel)]='input.email' id="inputEmail" name="inputEmail" class="form-control" required autofocus>
							<label for="inputPassword" class="loginLabel">{{LOCALIZATION.password}}</label>
								<input uib-tooltip-html="popoverHTML" tooltip-is-open="showPolicy" tooltip-trigger="none" tooltip-placement="top" tooltip-class="checklist" 
									type="password" [(ngModel)]='input.newpass' (change)="validatePassword()" (focus)="showPolicy=true" (blur)="showPolicy=false" name="newpass" id="inputPassword" class="form-control" required>
								<span *ngIf="showPolicy" [innerHTML]="popoverHTML"></span>
							<label for="inputPassword2" class="loginLabel">{{LOCALIZATION.passwordRetype}}</label>
								<input type="password" [(ngModel)]='input.newpass2' id="inputPassword2" name="inputPassword2" class="form-control" required>
							<label for="inputFirstName" class="loginLabel">{{LOCALIZATION.firstName}}</label>
								<input type="text" [(ngModel)]='input.firstname' id="inputFirstName" name="inputFirstName" class="form-control" required autofocus>
							<label for="inputLastName" class="loginLabel">{{LOCALIZATION.lastName}}</label>
								<input type="text" [(ngModel)]='input.lastname' id="inputLastName" name="inputLastName" class="form-control" required autofocus>
						</div>
						<div class="col-md-12">
							<div id='simplecaptcha' class="simplecaptcha text-center" >
								<div [ngClass]="{'hide': 'AUDIO' == captchaType}"><img src="{{captchaSource}}"></div>
								<div [ngClass]="{'hide': 'IMAGE' == captchaType}">
									<audio controls autoplay id="audioCaptcha" src="{{captchaAudioSource}}" style="width: 100%; max-width: 285px;"></audio>
								</div>								
								<div>
									<span for="captchaAnswer" class="loginLabel" [ngClass]="{'hide': 'AUDIO' == captchaType}">{{LOCALIZATION.captchaPrompt}}: </span>
									<span for="captchaAnswer" class="loginLabel" [ngClass]="{'hide': 'IMAGE' == captchaType}">{{LOCALIZATION.captchaPromptAudio}}: </span>
								</div>
								<div class="row">
									<div class="col-lg-12">
									  <div class="input-group">
									    <input type="text" class="form-control" style="font-size: 14px; padding: 6px 12px;" [(ngModel)]='input.captchaAnswer' id="captchaAnswer" name="captchaAnswer" required autofocus>
									    <span class="input-group-btn">
											<button (click)="refreshChallenge()" type="button" class="btn btn-md btn-primary">
												<span class="glyphicon glyphicon-refresh"></span>
											</button>
									    </span>
									  </div>
									</div>									
								</div>
								<div class="row">
									<button (click)="audioChallenge()" type="button" class="btn btn-link">
										{{LOCALIZATION.captchaTypeAudio}}
									</button>
									<button (click)="imageChallenge()" type="button" class="btn btn-link">
										{{LOCALIZATION.captchaTypeImage}}
									</button>									
								</div>
							</div>
						</div>
						<div class="primary-controls col-md-12">
							<button class="btn btn-default" type="button" (click)="cancel()" *ngIf="publicEnabled">{{LOCALIZATION.cancel}}</button>
							<button class="btn btn-primary" type="button" (click)="ok()">{{LOCALIZATION.register}}</button>
						</div>
					</div>
				</form>
			
				<form *ngIf='formMode === "userRecovery"' class="form-signin column">
					<div class="block">
						<div class="header">{{LOCALIZATION.usernameRetrieve}}</div>
						<p>{{LOCALIZATION.loginCredentialsPrompt}}</p>
					</div>	
					<div class="row">
						<div class="col-md-12">		
							<label for="inputEmail" class="loginLabel">{{LOCALIZATION.email}}</label>
							<input type="text" [(ngModel)]='input.email' id="inputEmail" name="inputEmail" class="form-control" required autofocus>
							<label for="inputFirstName" class="loginLabel">{{LOCALIZATION.firstName}}</label>
							<input type="text" [(ngModel)]='input.firstname' id="inputFirstName" name="inputFirstName" class="form-control" required autofocus>
							<label for="inputLastName" class="loginLabel">{{LOCALIZATION.lastName}}</label>
							<input type="text" [(ngModel)]='input.lastname' id="inputLastName" name="inputLastName" class="form-control" required autofocus>
						</div>
						<div class="col-md-12">
							<div id='simplecaptcha' class="simplecaptcha text-center" >
								<div [ngClass]="{'hide': 'AUDIO' == captchaType}"><img src="{{captchaSource}}"></div>
								<div [ngClass]="{'hide': 'IMAGE' == captchaType}">
									<audio controls autoplay id="audioCaptcha" src="{{captchaAudioSource}}" style="width: 100%; max-width: 285px;"></audio>
								</div>								
								<div>
									<span for="captchaAnswer" class="loginLabel" [ngClass]="{'hide': 'AUDIO' == captchaType}">{{LOCALIZATION.captchaPrompt}}: </span>
									<span for="captchaAnswer" class="loginLabel" [ngClass]="{'hide': 'IMAGE' == captchaType}">{{LOCALIZATION.captchaPromptAudio}}: </span>
								</div>
								<div class="row">
									<div class="col-lg-12">
									  <div class="input-group">
									    <input type="text" class="form-control" style="font-size: 14px; padding: 6px 12px;" [(ngModel)]='input.captchaAnswer' id="captchaAnswer" name="captchaAnswer" required autofocus>
									    <span class="input-group-btn">
											<button (click)="refreshChallenge()" type="button" class="btn btn-md btn-primary">
												<span class="glyphicon glyphicon-refresh"></span>
											</button>
									    </span>
									  </div>
									</div>									
								</div>
								<div class="row">
									<button (click)="audioChallenge()" type="button" class="btn btn-link">
										{{LOCALIZATION.captchaTypeAudio}}
									</button>
									<button (click)="imageChallenge()" type="button" class="btn btn-link">
										{{LOCALIZATION.captchaTypeImage}}
									</button>									
								</div>
							</div>
						</div>
						<div class="primary-controls col-md-12">
							<button class="btn btn-default" type="button" (click)="cancel()" *ngIf="publicEnabled">{{LOCALIZATION.cancel}}</button>
							<button class="btn btn-primary" type="button" (click)="ok()">{{LOCALIZATION.emailSend}}</button>
						</div>
					</div>
				</form>
			
				<form *ngIf='formMode === "passwordRecovery"' class="form-signin column" method="post">
					<div class="block">
						<div class="header">{{LOCALIZATION.passwordRetrieve}}</div>
						<p>{{LOCALIZATION.loginCredentialsPrompt}}</p>
					</div>
					<div class="row">		
						<div class="col-md-12">
							<label for="inputUser" class="loginLabel">{{LOCALIZATION.username}}</label>
							<input type="text" [(ngModel)]='input.username' id="inputUser" name="inputUser" class="form-control" required autofocus>
							<label for="inputEmail" class="loginLabel">{{LOCALIZATION.email}}</label>
							<input type="text" [(ngModel)]='input.email' id="inputEmail" name="inputEmail" class="form-control" required>
						</div>
						<div class="col-md-12">
							<div id='simplecaptcha' class="simplecaptcha text-center" >
								<div [ngClass]="{'hide': 'AUDIO' == captchaType}"><img src="{{captchaSource}}"></div>
								<div [ngClass]="{'hide': 'IMAGE' == captchaType}">
									<audio controls autoplay id="audioCaptcha" src="{{captchaAudioSource}}" style="width: 100%; max-width: 285px;"></audio>
								</div>								
								<div>
									<span for="captchaAnswer" class="loginLabel" [ngClass]="{'hide': 'AUDIO' == captchaType}">{{LOCALIZATION.captchaPrompt}}: </span>
									<span for="captchaAnswer" class="loginLabel" [ngClass]="{'hide': 'IMAGE' == captchaType}">{{LOCALIZATION.captchaPromptAudio}}: </span>
								</div>
								<div class="row">
									<div class="col-lg-12">
									  <div class="input-group">
									    <input type="text" class="form-control" style="font-size: 14px; padding: 6px 12px;" [(ngModel)]='input.captchaAnswer' id="captchaAnswer" name="captchaAnswer" required autofocus>
									    <span class="input-group-btn">
											<button (click)="refreshChallenge()" type="button" class="btn btn-md btn-primary">
												<span class="glyphicon glyphicon-refresh"></span>
											</button>
									    </span>
									  </div>
									</div>									
								</div>
								<div class="row">
									<button (click)="audioChallenge()" type="button" class="btn btn-link">
										{{LOCALIZATION.captchaTypeAudio}}
									</button>
									<button (click)="imageChallenge()" type="button" class="btn btn-link">
										{{LOCALIZATION.captchaTypeImage}}
									</button>									
								</div>
							</div>
						</div>
						<div class="primary-controls col-md-12">
							<button class="btn btn-default" type="button" (click)="cancel()" *ngIf="publicEnabled">{{LOCALIZATION.cancel}}</button>
							<button class="btn btn-primary" type="button" (click)="ok()">{{LOCALIZATION.emailSend}}</button>
						</div>	
					</div>
				</form>	
				<div class="column form-signin">
					<div class="row">
						<div class="col-md-12 links-container">
							<div *ngIf='(formMode === "register" || formMode === "login" || formMode === "passwordRecovery") && passwordEnabled && !isHideBasicAuthentication' class='signin-left'>
								<label>
									<a href="#" (click)='changeFormMode("userRecovery", $event)'>{{LOCALIZATION.usernameForgot}}</a>
								</label>
							</div>
							<div *ngIf='(formMode === "register" || formMode === "login" || formMode === "userRecovery") && passwordEnabled  && !isHideBasicAuthentication' class='signin-left'>
								<label>
									<a href="#" (click)='changeFormMode("passwordRecovery", $event)'>{{LOCALIZATION.passwordForgot}}</a>
								</label>
							</div>
							<div *ngIf='(formMode === "userRecovery" || formMode === "passwordRecovery" || formMode === "login") && passwordEnabled && registerEnabled  && !isHideBasicAuthentication' class='signin-left'>
								<label>
									{{LOCALIZATION.registerPrompt}}
									<a href="#" (click)='changeFormMode("register", $event)'>{{LOCALIZATION.register}}</a>
								</label>
							</div>
							<div *ngIf='(formMode === "passwordRecovery" || formMode === "register" || formMode === "userRecovery") && passwordEnabled  && !isHideBasicAuthentication' class='signin-left'>
								<label>
									{{LOCALIZATION.loginPrompt}}
									<a href="#" (click)='changeFormMode("login", $event)'>{{LOCALIZATION.login}}</a>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div> 
		</div>
		<div class="image-container">
			<div class="block">
				<div class="header"></div>
				<div class="copy"></div>
			</div>
		    <div class="login-page-logo-large center-block" aria-hidden="true" role="presentation"></div>			
		</div>
	</div>
</div>
